<template>
  <div
    :class="{ 'fixed-width': fixedWidth }"
    class="courses">
    <template v-for="(course, index) in courses">
      <div
        :key="index"
        class="app-card course"
        @click="$router.push(`/course/${course.course_code}`)">
        <div
          class="card-image" >
          <img :src="course.course_thumbnail" class="image_course_thumbnail">
        </div>
        <div class="card-content">
          <article>
            <h4 class="title">{{ course.course_title }}</h4>
            <p class="tutor-name">ผู้สอน : {{ course.course_instructor }}</p>
            <p class="tutor-career">ตำแหน่งอาชีพ : {{ course.course_instructor_position }}</p>
          </article>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'course',

    props: {
      courses: {
        type: Array,
        default: null
      },
      fixedWidth: {
        type: Boolean,
        default: false
      }
    },

    watch: {
      courses: val => {
        this.courses = val
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/styles";

  .image_course_thumbnail{
    height: 100%;
    width: 100%;
    object-fit: contain;
  }

  .courses {
    @extend .d-flex;
    overflow: auto;

    .course {
      flex: none;
      width: 100%;
      margin-right: 0;
      margin-left: 0;
    }

    &.fixed-width {
      .course {
        width: 60vw;
        margin-right: 5px;
        margin-left: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/learning/Courses.component.vue